import React, { useState, useRef, useEffect } from "react";
import * as CS from "../../../styles/ControlStyled";
import muteIcon from "../../../assets/images/mutes.png";
import pause from "../../../assets/images/pause.png";
import play from "../../../assets/images/play.png";
import unmute from "../../../assets/images/unmute.png";
import fullScreen from "../../../assets/images/fullScreen.png";
import styled from "styled-components";

const Control = ({
  playing,
  played,
  onVolumeChange,
  volume,

  duration,
  currentTime,
  controlRef,
  onPlay,
  onPause,
  handleMute,
  isMuted,
  seek,
  handleSeekChange,
  handleSeekForward,
  handleNothing,
  qualities,
  handleQualityChange,
  currentQuality,
  toggleFullScreen,
  handleProgress,
  isForward,
  isBackward,
  videoPlayerRef,
  maxWatchedTime,
  controlsVisible,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isQuality, setIsQuality] = useState(false);
  const [isSeekControl, setIsSeekControl] = useState({});
  const profileRef = useRef(null);
  // console.log(qualities, "qualities qualities");
  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsQuality(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileRef]);

  // console.log(currentQuality, "currentQuality currentQuality");

  const handleSeekBar = (e) => {
    if (e.isForward && e.isBackward) {
      return handleNothing;
    } else if (e.isForward) {
      return handleSeekForward;
    } else if (e.isBackward) {
      return handleSeekChange;
    } else {
      return () => {};
    }
  };

  useEffect(() => {
    setIsSeekControl({
      isForward,
      isBackward,
    });
  }, [isForward, isBackward]);

  // console.log(isSeekControl, "isSeekControl isSeekControl");

  const maxValue = (maxWatchedTime / videoPlayerRef?.current?.duration) * 100;
  return (
    <CS.ControlsContainer ref={controlRef}
     style={{
    opacity: controlsVisible ? 1 : 0,
    transition: 'opacity 0.3s ease',
    pointerEvents: controlsVisible ? 'auto' : 'none'
  }}
    >
      <CS.MidContainer>
        {/* {playing ? (
          <CS.IconButton onClick={onPause}>
            <img src={pause} alt="" />
          </CS.IconButton>
        ) : (
          <CS.IconButton onClick={onPlay}>
            <img src={play} alt="" />
          </CS.IconButton>
        )} */}
      </CS.MidContainer>
      <CS.ControlBox>
        <CS.InnerControlBox>
          <CS.InnerControls visible={isVisible}>
            {playing ? (
              <CS.IconButton onClick={onPause}>
                <img src={pause} alt="" />
              </CS.IconButton>
            ) : (
              <CS.IconButton onClick={onPlay}>
                <img src={play} alt="" />
              </CS.IconButton>
            )}
            <CS.IconButtonsContainer>
              <CS.IconButtonsContainers
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
              >
                <CS.IconButtons onClick={handleMute}>
                  <img src={isMuted ? muteIcon : unmute} alt="" />
                </CS.IconButtons>
                <CS.VolumeSlider
                  visible={isVisible}
                  onChange={onVolumeChange}
                  value={volume}
                />
              </CS.IconButtonsContainers>
              <CS.Seektime visible={isVisible}>
                <p>
                  {currentTime} / {duration}
                </p>
              </CS.Seektime>
            </CS.IconButtonsContainer>
          </CS.InnerControls>
          <CS.SliderContainer visible={isVisible}>
            <div style={{ width: "100%", position: "relative" }}>
              <CS.SeekSlider
                value={seek}
                // onChange={false ? handleNothing : handleSeekChange}
                onChange={handleSeekBar(isSeekControl)}
              />
              <div
                style={{
                  position: "absolute",
                  left: isSeekControl?.isBackward ? `${maxValue}%` : 0,
                  right: isSeekControl?.isForward ? `${100 - maxValue}%` : 0,
                  top: 0,
                  bottom: 0,
                  backgroundColor: "rgba(255, 255, 255, 0)",
                  pointerEvents: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </CS.SliderContainer>
        </CS.InnerControlBox>
        <CS.BottomContainer>
          <CS.QualityLabel
            isFK={currentQuality === 5}
            onClick={() => {
              setIsQuality(!isQuality);
            }}
          >
            {currentQuality === -1
              ? "Auto"
              : qualities?.length > 0
              ? qualities?.filter((val, ind) => ind === currentQuality)[0]
                  ?.resolution
              : ""}
          </CS.QualityLabel>
          <img onClick={toggleFullScreen} src={fullScreen} alt="" />
          {isQuality ? (
            <CS.QualityContainer ref={profileRef}>
              {/* <p
                onClick={(e) => {
                  handleQualityChange(parseInt(-1, 10));
                  setIsQuality(false);
                }}
              >
                Auto
              </p> */}
              {qualities?.map((val, ind) => {
                console.log(val?.resolution);
                return (
                  <p
                    onClick={(e) => {
                      handleQualityChange(parseInt(ind, 10));
                      setIsQuality(false);
                    }}
                    key={val}
                  >
                    {val.resolution}
                    {/* {val?.height}p */}
                  </p>
                );
              })}
            </CS.QualityContainer>
          ) : (
            ""
          )}
        </CS.BottomContainer>
      </CS.ControlBox>
    </CS.ControlsContainer>
  );
};

export default Control;
